export default (Vue) => {
  Vue.filter('capitalize', function (value) {
    if (!value) {
      return '';
    }
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  });

  Vue.filter('number', function (value) {
    return value ? parseFloat(value.toFixed(3)) : value;
  });
};



// WEBPACK FOOTER //
// ./src/constants/filters.js